import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { Container } from '@mui/system';
import Grid from '@mui/material/Grid';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DetailsItem from './DetailsItem'
import DeleteItemDialog from './DeleteItemDialog'
import AddItem from './AddItem'
import UpdateItem from './UpdateItem'
import LoaderDialog from './LoaderDialog'
import { AuthContext } from '../authContext/AuthContext';

const ListItems = () => {
  const isMounted = React.useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const [data, setData] = useState();
  const [detailsDialog, setDetailsDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [contextMenu, setContextMenu] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [addDialog, setAddDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const {user, shop} = useContext(AuthContext)

  useEffect(() => {
    loadData(user, shop);
  },[user, shop]);

  const loadData = async(user, shop) => {
    try {
      setLoading(true)
      const columns = [
        {"field": "itemKey", "headerName": "Key"},
        {"field": "itemName", "headerName": "Name", width: 200, editable: true},
        {"field": "itemMainCategory", "headerName": "Main Category",  width: 125},
        {"field": "cgst", "headerName": "CGST"},
        {"field": "sgst", "headerName": "SGST"},
        {"field": "sellingPriceInclTax", "headerName": "SP Incl Tax"},
        {"field": "stock", "headerName": "Stock"},
        {"field": "unitOfMeasurement", "headerName": "Unit Type"},
        {"field": "active", "headerName": "Active"}
      ]
      let sd = []
      const res = await axios.get("/items", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      if (!isMounted.current) return;
      res.data.map(async (item)=> {
        sd.push({...item, "id": item._id})
      });
      if(sd) {
        setData({"rows": sd, "columns": columns})
      }
      setLoading(false)
    } catch (err) {
      console.log(err)
      if (isMounted.current) setLoading(false)
    }
  }
  
  const handleContextMenu = (event) => {
    event.preventDefault()
    setSelectedRow(event.currentTarget.getAttribute('data-id'))
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null,
    );
  };

  const addItem = async() => {
    handleClose()
    setAddDialog(true);
  }
  const handleAddClose = () => {
    setAddDialog(false);
    loadData(user, shop);
  };
  const updateItem = async(id) => {
    handleClose()
    setUpdateDialog(true);
  }
  const handleClose = () => {
    setContextMenu(null);
  };

  const handleDetailsClose = () => {
    setDetailsDialog(false);
  };

  const detailsItem = async() => {
    handleClose()
    setDetailsDialog(true);
  }

  const handleUpdateClose = () => {
    setUpdateDialog(false);
    loadData(user, shop);
  };

  const deleteItem = async(id) => {
    await axios.delete("/items/softdelete/" + id, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
    handleCloseAlert();
    loadData(user, shop);
  }
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };
  const handleClickOpenAlert = () => {
    handleClose();
    setOpenAlert(true);
  };
  return (
    <div>
    <Container maxWidth="false" disableGutters sx={{height: "85vh", width: "100vw"}}>
      <LoaderDialog open={loading} title="Loading Items ..."/>
      <Grid container>
        {data && 
        <div>
          <DataGrid {...data} 
            components={{ Toolbar: GridToolbar }}  
            componentsProps={{row: {onContextMenu: handleContextMenu,style: { cursor: 'context-menu' }}}} 
            sx={{height: "92vh", width: "100vw"}}/>
          <Menu
            open={contextMenu !== null}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined
            }
            componentsProps={{
              root: {
                onContextMenu: (e) => {
                  e.preventDefault();
                  handleClose();
                },
              },
            }}>
            <MenuItem onClick={addItem}>Add</MenuItem>
            <MenuItem onClick={updateItem}>Update</MenuItem>
            <MenuItem onClick={handleClickOpenAlert}>Delete</MenuItem>
            <MenuItem onClick={detailsItem}>Details</MenuItem>
          </Menu>
        </div>}
      </Grid>
    </Container>
    <AddItem addDialog={addDialog} handleClose={handleAddClose} items={data ? data.rows : []} />
    <UpdateItem updateDialog={updateDialog} handleClose={handleUpdateClose} updateItemId={selectedRow} items={data ? data.rows : []} />
    <DeleteItemDialog open={openAlert} handleClose={handleCloseAlert} itemDelete={selectedRow} handleDeleteItem={deleteItem}/>
    <DetailsItem detailsDialog={detailsDialog} handleClose={handleDetailsClose} detailsItemId={selectedRow}/>
    </div>
  )
}

export default ListItems
